import { render, staticRenderFns } from "./CustomStyle.vue?vue&type=template&id=dbbb9b48&scoped=true&"
import script from "./CustomStyle.vue?vue&type=script&lang=js&"
export * from "./CustomStyle.vue?vue&type=script&lang=js&"
import style0 from "./CustomStyle.vue?vue&type=style&index=0&id=dbbb9b48&lang=scss&scoped=true&"
import style1 from "./CustomStyle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbb9b48",
  null
  
)

export default component.exports